export const SET_PROGRESS_PAGE_TYPE = "SET_PROGRESS_PAGE_TYPE";
export const RESET_PROGRESS_PAGE_TYPE = "RESET_PROGRESS_PAGE_TYPE";
